import { render, staticRenderFns } from "./IdCardUpload.vue?vue&type=template&id=467e2b19&scoped=true"
import script from "./IdCardUpload.vue?vue&type=script&lang=js"
export * from "./IdCardUpload.vue?vue&type=script&lang=js"
import style0 from "./IdCardUpload.vue?vue&type=style&index=0&id=467e2b19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467e2b19",
  null
  
)

export default component.exports